module.exports = __webpack_public_path__ + "media/landing_page/google-play-icon-kale-3213eb3f.svg";